import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'

export function* getRecommendationList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.RECOMMENDATION.RECOMMENDATION_LIST, data);
        if (resp.status >= 200 && resp.status < 300) {
            console.log(resp.data); 
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e);
    }
}

